import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {generateUniqueId} from "../../firebase/firebase-doc-util";
import {DATA_LIMIT} from "../constants/pinterest.constant";

export {
    saveSinglePinterestImage,
    addPinterestImages,
    addSinglePinterestImage,
    updateSinglePinterestImage,
    getSinglePinterestImage,
    searchPinterestImages,
    searchPinterestImagesWithSearchCriteria,
    preparePinterestImagesList
}

const collectionName = 'pinterest-images';
const collectionReference = collection(fireStoreDB, collectionName);

const saveSinglePinterestImage = (pinterestImage) => {
    if (!pinterestImage?.id) {
        pinterestImage.id = generateUniqueId();
    }

    const documentReference = doc(fireStoreDB, collectionName, pinterestImage.id);

    pinterestImage.updatedAt = new Date();
    if (!pinterestImage.createdAt) {
        pinterestImage.createdAt = pinterestImage.updatedAt;
    }

    return setDoc(documentReference, pinterestImage, {merge: true});
}

const addPinterestImages = (pinterestImages) => {
    return Promise.map(pinterestImages, async pinterestImage => {
        await addSinglePinterestImage(pinterestImage);
    });
}

const addSinglePinterestImage = (pinterestImage) => {
    pinterestImage.createdAt = new Date();
    pinterestImage.updatedAt = pinterestImage.createdAt;
    return addDoc(collectionReference, pinterestImage);
}

const updateSinglePinterestImage = (pinterestImage) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestImage.id);
    pinterestImage.updatedAt = new Date();
    return setDoc(documentReference, pinterestImage);
}

const getSinglePinterestImage = async (pinterestImageId) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestImageId);
    const pinterestImageDoc = await getDoc(documentReference);
    return prepareSinglePinterestImage(pinterestImageDoc);
}

const searchPinterestImages = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const pinterestImageResult = await getDocs(searchQuery);
    return preparePinterestImagesList(pinterestImageResult);
}

const searchPinterestImagesWithSearchCriteria = async (searchCriteriaList, datalimit = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPinterestImagesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    if (datalimit > 0) {
        searchQuery = query(searchQuery, limit(datalimit));
    }

    const pinterestImageResult = await getDocs(searchQuery);
    return preparePinterestImagesList(pinterestImageResult);
}

const preparePinterestImagesList = (pinterestImageResult) => {
    const pinterestImagesList = [];

    _.forEach(pinterestImageResult.docs, pinterestImageDoc => {
        pinterestImagesList.push(prepareSinglePinterestImage(pinterestImageDoc));
    });

    return pinterestImagesList;
}


const prepareSinglePinterestImage = (pinterestImageDoc) => {
    const pinterestImage = pinterestImageDoc.data();
    pinterestImage.id = pinterestImageDoc.id;
    return pinterestImage;
}
